import axios from "axios";
import React, { Component } from "react";
import { authService } from "../auth";
import * as _ from "lodash";
import { rankFormatFunction } from "../commons/CommonFunctions";
import { withRouter } from "react-router-dom";

class HomePageBadge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            userBadgePoint: {},
            showPublic: false,
            responseMessage: ""
        }
    }

    getUserBadgePoint = () => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/backend/badge/get?userId=${this.state.userData.userId}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response.data.message === 'Success!') {
                this.setState({
                    userBadgePoint: response?.data?.body
                })
            }
            this.setState({
                responseMessage: "Success!"
            })
        }).catch((err) => {
            console.log(err);
            this.setState({
                responseMessage: "Success!"
            })
        });
    }

    getBadgeShowInPublic = () => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/backend/badge/config/show/public`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response.data.message === 'Success!') {
                this.setState({
                    showPublic: response?.data?.body
                })
                if(this.props.pageType && this.props.getShowInPublicData) {
                    this.props.getShowInPublicData(response?.data?.body);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    redirectToBadgeDashboard = () => {
        this.props.history.push({
            pathname: '/dashboard'
        })
    }

    componentDidMount() {
        this.getUserBadgePoint();
        this.getBadgeShowInPublic();
    }

    render() {
        const { userBadgePoint, responseMessage, showPublic } = this.state;
        return (
            <>
                {responseMessage && showPublic &&
                    <div className='pntRnkBdgWrap rkhsd'>
                        <div className={'prbCol point' + (!userBadgePoint?.point ? " blank" : "")} id={"badge-points"}>
                            {userBadgePoint?.point > 0 ? 
                                <>
                                    <figure>
                                        <img src='https://cdn.dscovr.com/images/token-624.png' alt='images' />
                                    </figure>
                                    <div className='prbColDesc'>
                                        <span>{userBadgePoint?.point}</span> Points
                                    </div>
                                </>
                                : 
                                <div className="zeroData">
                                    <figure>
                                        <img src='https://cdn.dscovr.com/images/token96.png' alt='images' width='45px' style={{ minWidth: '32px'}} />
                                    </figure>
                                    <strong>0 Points</strong>
                                    {/* <p>Dummy printing and typesetting</p> */}
                                </div>
                            }
                            <button type='button' onClick={() => this.redirectToBadgeDashboard()}></button>
                        </div>
                        <div className={'prbCol rank' + (!userBadgePoint?.rank ? " blank" : "")} id={"rank-points"}>
                            {userBadgePoint?.rank > 0 ?
                                <>
                                    <figure>                                    
                                        <img src='https://cdn.dscovr.com/images/token-626.png' alt='images' />
                                    </figure>
                                    <div className='prbColDesc'>
                                        <span>{userBadgePoint?.rank}{!_.isEmpty(userBadgePoint) && rankFormatFunction(userBadgePoint?.rank)}</span> Rank
                                    </div>
                                </>
                                :
                                <div className="zeroData">
                                    <figure>                                    
                                        <img src='https://cdn.dscovr.com/images/ranking94.png' alt='images' width='45px' style={{ minWidth: '32px'}} />
                                    </figure>
                                    <strong>Unranked</strong>
                                    {/* <p>Dummy printing and typesetting</p> */}
                                </div>
                            }
                            <button type='button' onClick={() => this.redirectToBadgeDashboard()}></button>
                        </div>
                        <div className={'prbCol badge' + (userBadgePoint && !userBadgePoint?.badgeType ? " blank" : "")} id={"badge1-points"}>
                            {userBadgePoint?.badgeType ?
                                <>
                                    <figure>
                                        <img src={userBadgePoint?.badgeType === "SILVER" ? 'https://cdn.dscovr.com/images/silverbadge21.png' : userBadgePoint?.badgeType === "GOLD" ? 'https://cdn.dscovr.com/images/goldenbadges11.png' : 'https://cdn.dscovr.com/images/platinumbadge31.png'} alt='images' width='48px' style={{ minWidth: '32px'}} />
                                    </figure>
                                    <div className='prbColDesc'>
                                        Badge Earned
                                    </div>
                                </>
                                :
                                <div className="zeroData">
                                    <figure>
                                        <img src='https://cdn.dscovr.com/images/badge94.png' alt='images' width='45px' style={{ minWidth: '32px'}} />
                                    </figure>
                                    <strong>No badge earned</strong>
                                    {/* <p>You haven't earned any badge yet</p> */}
                                </div>
                            }
                            <button type='button' onClick={() => this.redirectToBadgeDashboard()}></button>
                        </div>
                    </div>
                }
            </>
        )
    }
}

export default withRouter(HomePageBadge);